/* global axios */
import ApiClient from './ApiClient';

class EfiConfigAPI extends ApiClient {
  constructor() {
    super('efi_config', { accountScoped: true });
  }

  // Multipart: o certificado .p12 vai como arquivo.
  update(config) {
    const formData = new FormData();
    Object.entries(config).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(`efi_config[${key}]`, value);
      }
    });
    return axios.patch(this.url, formData);
  }
}

export default new EfiConfigAPI();
